var _regeneratorRuntime = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/regenerator/index.js");

!function webpackUniversalModuleDefinition(e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define([], r) : "object" == typeof exports ? exports["@wordpress/redux-routine"] = r() : (e.wp = e.wp || {}, e.wp.reduxRoutine = r());
}(self, function () {
  return function () {
    var e = {
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      858: function _(e, r, t) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: !0
        }), r.isAction = isAction, r.isActionOfType = function isActionOfType(e, r) {
          return isAction(e) && e.type === r;
        };
        var n = t(793);

        function isAction(e) {
          return (0, n.isPlainObject)(e) && (0, n.isString)(e.type);
        }
      },
      497: function _(e, r) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: !0
        }), r.default = function isGenerator(e) {
          return !!e && "function" == typeof e[Symbol.iterator] && "function" == typeof e.next;
        };
      },
      552: function _(e, r, t) {
        "use strict";

        var n = t(424);
        Object.defineProperty(r, "__esModule", {
          value: !0
        }), r.default = function createRuntime() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = arguments.length > 1 ? arguments[1] : void 0;

          var t = (0, o.map)(e, function (e, r) {
            return function (t, n, u, o, c) {
              if (!(0, a.isActionOfType)(t, r)) return !1;
              var f = e(t);
              return (0, i.default)(f) ? f.then(o, c) : o(f), !0;
            };
          }),
              unhandledActionControl = function unhandledActionControl(e, t) {
            return !!(0, a.isAction)(e) && (r(e), t(), !0);
          };

          t.push(unhandledActionControl);
          var n = (0, u.create)(t);
          return function (e) {
            return new Promise(function (t, u) {
              return n(e, function (e) {
                (0, a.isAction)(e) && r(e), t(e);
              }, u);
            });
          };
        };
        var u = t(80),
            o = t(793),
            i = n(t(626)),
            a = t(858);
      },
      626: function _(e) {
        function isPromise(e) {
          return !!e && ("object" == typeof e || "function" == typeof e) && "function" == typeof e.then;
        }

        e.exports = isPromise, e.exports.default = isPromise;
      },
      41: function _(e, r, t) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: !0
        }), r.race = r.join = r.fork = r.promise = void 0;

        var n = _interopRequireDefault(t(399)),
            u = t(976),
            o = _interopRequireDefault(t(980));

        function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }

        var i = r.promise = function promise(e, r, t, u, o) {
          return !!n.default.promise(e) && (e.then(r, o), !0);
        },
            a = new Map(),
            c = r.fork = function fork(e, r, t) {
          if (!n.default.fork(e)) return !1;
          var i = Symbol("fork"),
              c = (0, o.default)();
          a.set(i, c), t(e.iterator.apply(null, e.args), function (e) {
            return c.dispatch(e);
          }, function (e) {
            return c.dispatch((0, u.error)(e));
          });
          var f = c.subscribe(function () {
            f(), a.delete(i);
          });
          return r(i), !0;
        },
            f = r.join = function join(e, r, t, u, o) {
          if (!n.default.join(e)) return !1;
          var i,
              c = a.get(e.task);
          return c ? i = c.subscribe(function (e) {
            i(), r(e);
          }) : o("join error : task not found"), !0;
        },
            l = r.race = function race(e, r, t, u, o) {
          if (!n.default.race(e)) return !1;

          var i,
              a = !1,
              c = function success(e, t, n) {
            a || (a = !0, e[t] = n, r(e));
          },
              f = function fail(e) {
            a || o(e);
          };

          return n.default.array(e.competitors) ? (i = e.competitors.map(function () {
            return !1;
          }), e.competitors.forEach(function (e, r) {
            t(e, function (e) {
              return c(i, r, e);
            }, f);
          })) : function () {
            var r = Object.keys(e.competitors).reduce(function (e, r) {
              return e[r] = !1, e;
            }, {});
            Object.keys(e.competitors).forEach(function (n) {
              t(e.competitors[n], function (e) {
                return c(r, n, e);
              }, f);
            });
          }(), !0;
        };

        r.default = [i, c, f, l, function subscribe(e, r) {
          if (!n.default.subscribe(e)) return !1;
          if (!n.default.channel(e.channel)) throw new Error('the first argument of "subscribe" must be a valid channel');
          var t = e.channel.subscribe(function (e) {
            t && t(), r(e);
          });
          return !0;
        }];
      },
      988: function _(e, r, t) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: !0
        }), r.iterator = r.array = r.object = r.error = r.any = void 0;

        var n = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }(t(399));

        var u = r.any = function any(e, r, t, n) {
          return n(e), !0;
        },
            o = r.error = function error(e, r, t, u, o) {
          return !!n.default.error(e) && (o(e.error), !0);
        },
            i = r.object = function object(e, r, t, u, o) {
          if (!n.default.all(e) || !n.default.obj(e.value)) return !1;
          var i = {},
              a = Object.keys(e.value),
              c = 0,
              f = !1;
          return a.map(function (r) {
            t(e.value[r], function (e) {
              return function gotResultSuccess(e, r) {
                f || (i[e] = r, ++c === a.length && u(i));
              }(r, e);
            }, function (e) {
              return function gotResultError(e, r) {
                f || (f = !0, o(r));
              }(0, e);
            });
          }), !0;
        },
            a = r.array = function array(e, r, t, u, o) {
          if (!n.default.all(e) || !n.default.array(e.value)) return !1;
          var i = [],
              a = 0,
              c = !1;
          return e.value.map(function (r, n) {
            t(r, function (r) {
              return function gotResultSuccess(r, t) {
                c || (i[r] = t, ++a === e.value.length && u(i));
              }(n, r);
            }, function (e) {
              return function gotResultError(e, r) {
                c || (c = !0, o(r));
              }(0, e);
            });
          }), !0;
        },
            c = r.iterator = function iterator(e, r, t, u, o) {
          return !!n.default.iterator(e) && (t(e, r, o), !0);
        };

        r.default = [o, c, a, i, u];
      },
      925: function _(e, r, t) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: !0
        }), r.cps = r.call = void 0;

        var n = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }(t(399));

        var u = r.call = function call(e, r, t, u, o) {
          if (!n.default.call(e)) return !1;

          try {
            r(e.func.apply(e.context, e.args));
          } catch (e) {
            o(e);
          }

          return !0;
        },
            o = r.cps = function cps(e, r, t, u, o) {
          var i;
          return !!n.default.cps(e) && ((i = e.func).call.apply(i, [null].concat(function _toConsumableArray(e) {
            if (Array.isArray(e)) {
              for (var r = 0, t = Array(e.length); r < e.length; r++) {
                t[r] = e[r];
              }

              return t;
            }

            return Array.from(e);
          }(e.args), [function (e, t) {
            e ? o(e) : r(t);
          }])), !0);
        };

        r.default = [u, o];
      },
      869: function _(e, r, t) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: !0
        });

        var n = _interopRequireDefault(t(988)),
            u = _interopRequireDefault(t(399));

        function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }

        function _toConsumableArray(e) {
          if (Array.isArray(e)) {
            for (var r = 0, t = Array(e.length); r < e.length; r++) {
              t[r] = e[r];
            }

            return t;
          }

          return Array.from(e);
        }

        r.default = function create() {
          var e = arguments.length <= 0 || void 0 === arguments[0] ? [] : arguments[0],
              r = [].concat(_toConsumableArray(e), _toConsumableArray(n.default)),
              t = function runtime(e) {
            var t = arguments.length <= 1 || void 0 === arguments[1] ? function () {} : arguments[1],
                n = arguments.length <= 2 || void 0 === arguments[2] ? function () {} : arguments[2],
                o = function iterate(e) {
              var u = function yieldValue(r) {
                return function (u) {
                  try {
                    var i = r ? e.throw(u) : e.next(u),
                        a = i.value;
                    if (i.done) return t(a);
                    o(a);
                  } catch (e) {
                    return n(e);
                  }
                };
              },
                  o = function next(e) {
                r.some(function (r) {
                  return r(e, next, runtime, u(!1), u(!0));
                });
              };

              u(!1)();
            },
                i = u.default.iterator(e) ? e : _regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(r) {
                for (;;) {
                  switch (r.prev = r.next) {
                    case 0:
                      return r.next = 2, e;

                    case 2:
                      return r.abrupt("return", r.sent);

                    case 3:
                    case "end":
                      return r.stop();
                  }
                }
              }, _callee, this);
            })();

            o(i, t, n);
          };

          return t;
        };
      },
      80: function _(e, r, t) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: !0
        }), r.wrapControls = r.asyncControls = r.create = void 0;
        var n = t(976);
        Object.keys(n).forEach(function (e) {
          "default" !== e && Object.defineProperty(r, e, {
            enumerable: !0,
            get: function get() {
              return n[e];
            }
          });
        });

        var u = _interopRequireDefault(t(869)),
            o = _interopRequireDefault(t(41)),
            i = _interopRequireDefault(t(925));

        function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }

        r.create = u.default, r.asyncControls = o.default, r.wrapControls = i.default;
      },
      980: function _(e, r) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: !0
        });

        r.default = function createDispatcher() {
          var e = [];
          return {
            subscribe: function subscribe(r) {
              return e.push(r), function () {
                e = e.filter(function (e) {
                  return e !== r;
                });
              };
            },
            dispatch: function dispatch(r) {
              e.slice().forEach(function (e) {
                return e(r);
              });
            }
          };
        };
      },
      976: function _(e, r, t) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: !0
        }), r.createChannel = r.subscribe = r.cps = r.apply = r.call = r.invoke = r.delay = r.race = r.join = r.fork = r.error = r.all = void 0;

        var n = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }(t(167));

        r.all = function all(e) {
          return {
            type: n.default.all,
            value: e
          };
        }, r.error = function error(e) {
          return {
            type: n.default.error,
            error: e
          };
        }, r.fork = function fork(e) {
          for (var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), u = 1; u < r; u++) {
            t[u - 1] = arguments[u];
          }

          return {
            type: n.default.fork,
            iterator: e,
            args: t
          };
        }, r.join = function join(e) {
          return {
            type: n.default.join,
            task: e
          };
        }, r.race = function race(e) {
          return {
            type: n.default.race,
            competitors: e
          };
        }, r.delay = function delay(e) {
          return new Promise(function (r) {
            setTimeout(function () {
              return r(!0);
            }, e);
          });
        }, r.invoke = function invoke(e) {
          for (var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), u = 1; u < r; u++) {
            t[u - 1] = arguments[u];
          }

          return {
            type: n.default.call,
            func: e,
            context: null,
            args: t
          };
        }, r.call = function call(e, r) {
          for (var t = arguments.length, u = Array(t > 2 ? t - 2 : 0), o = 2; o < t; o++) {
            u[o - 2] = arguments[o];
          }

          return {
            type: n.default.call,
            func: e,
            context: r,
            args: u
          };
        }, r.apply = function apply(e, r, t) {
          return {
            type: n.default.call,
            func: e,
            context: r,
            args: t
          };
        }, r.cps = function cps(e) {
          for (var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), u = 1; u < r; u++) {
            t[u - 1] = arguments[u];
          }

          return {
            type: n.default.cps,
            func: e,
            args: t
          };
        }, r.subscribe = function subscribe(e) {
          return {
            type: n.default.subscribe,
            channel: e
          };
        }, r.createChannel = function createChannel(e) {
          var r = [];
          return e(function next(e) {
            return r.forEach(function (r) {
              return r(e);
            });
          }), {
            subscribe: function subscribe(e) {
              return r.push(e), function () {
                return r.splice(r.indexOf(e), 1);
              };
            }
          };
        };
      },
      399: function _(e, r, t) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: !0
        });

        var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
        },
            u = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }(t(167));

        var o = {
          obj: function obj(e) {
            return "object" === (void 0 === e ? "undefined" : n(e)) && !!e;
          },
          all: function all(e) {
            return o.obj(e) && e.type === u.default.all;
          },
          error: function error(e) {
            return o.obj(e) && e.type === u.default.error;
          },
          array: Array.isArray,
          func: function func(e) {
            return "function" == typeof e;
          },
          promise: function promise(e) {
            return e && o.func(e.then);
          },
          iterator: function iterator(e) {
            return e && o.func(e.next) && o.func(e.throw);
          },
          fork: function fork(e) {
            return o.obj(e) && e.type === u.default.fork;
          },
          join: function join(e) {
            return o.obj(e) && e.type === u.default.join;
          },
          race: function race(e) {
            return o.obj(e) && e.type === u.default.race;
          },
          call: function call(e) {
            return o.obj(e) && e.type === u.default.call;
          },
          cps: function cps(e) {
            return o.obj(e) && e.type === u.default.cps;
          },
          subscribe: function subscribe(e) {
            return o.obj(e) && e.type === u.default.subscribe;
          },
          channel: function channel(e) {
            return o.obj(e) && o.func(e.subscribe);
          }
        };
        r.default = o;
      },
      167: function _(e, r) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: !0
        });
        var t = {
          all: Symbol("all"),
          error: Symbol("error"),
          fork: Symbol("fork"),
          join: Symbol("join"),
          race: Symbol("race"),
          call: Symbol("call"),
          cps: Symbol("cps"),
          subscribe: Symbol("subscribe")
        };
        r.default = t;
      },
      793: function _(e) {
        "use strict";

        e.exports = require("lodash");
      }
    },
        r = {};

    function __webpack_require__(t) {
      var n = r[t];
      if (void 0 !== n) return n.exports;
      var u = r[t] = {
        exports: {}
      };
      return e[t](u, u.exports, __webpack_require__), u.exports;
    }

    var t = {};
    return function () {
      "use strict";

      var e = t,
          r = __webpack_require__(424);

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = function createMiddleware() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return function (r) {
          var t = (0, u.default)(e, r.dispatch);
          return function (e) {
            return function (r) {
              return (0, n.default)(r) ? t(r) : e(r);
            };
          };
        };
      };
      var n = r(__webpack_require__(497)),
          u = r(__webpack_require__(552));
    }(), t;
  }();
});